import { theme } from '~/theme';
import React from 'react';
import { Headline, Link as LinkType } from '~/lib/data-contract';
import { Link, Text } from '~/shared/components';
import { Button } from '~/shared/components/Button/Button';
import Flex from '~/shared/components/Flex';
import styles from './ModuleHeader.module.scss';

type ModuleHeaderProps = {
    headline?: Headline;
    subHeadline?: Headline;
    subSubHeadline?: Headline;
    link?: LinkType;
    textColor?: string;
    noGutter?: boolean;
};
export const ModuleHeader = ({
    headline,
    subHeadline,
    subSubHeadline,
    link,
    textColor,
}: ModuleHeaderProps) => {
    const headlineIsCampaign = headline?.style?.includes('Campaign');
    return (
        <>
            {!!headline && (
                <div className={styles.headerContainer}>
                    <div className={styles.headerSideContainer} />
                    <Flex alignItems="center" justifyContent="center" grow>
                        <div className={styles.headerHeadlines}>
                            {headline?.text && (
                                <Text
                                    as={headline.tag}
                                    variant={headline.style}
                                    children={headline.text}
                                    color={headline.textColor || textColor}
                                    data-testid="StyledHeadline"
                                />
                            )}
                            {subHeadline?.text && (
                                <Text
                                    className={styles.headerSubHeadline}
                                    as={subHeadline.tag}
                                    variant={subHeadline.style}
                                    children={subHeadline.text}
                                    color={subHeadline.textColor || textColor}
                                    style={{
                                        marginTop: headlineIsCampaign
                                            ? theme.space[3]
                                            : theme.space[1],
                                    }}
                                />
                            )}
                            {subSubHeadline?.text && (
                                <Text
                                    className={styles.headerSubHeadline}
                                    as={subSubHeadline.tag}
                                    variant={subSubHeadline.style}
                                    children={subSubHeadline.text}
                                    color={subSubHeadline.textColor || textColor}
                                    style={{
                                        marginTop: headlineIsCampaign
                                            ? theme.space[3]
                                            : theme.space[1],
                                    }}
                                />
                            )}
                        </div>
                    </Flex>
                    <div className={styles.headerSideContainer}>
                        {link?.url ? (
                            <Button
                                as={Link}
                                variant="link"
                                href={link.url}
                                children={link.text}
                                title={link.title}
                                target={link.target}
                                color={textColor}
                            />
                        ) : null}
                    </div>
                </div>
            )}
        </>
    );
};
